export function isNull(dateVal1, dateVal2) {
  if (dateVal1 !== '') {
    return dateVal1;
  }
  return dateVal2;
}
